import React, { useState, useEffect } from "react";
import classes from "./DropDown.scss";
import {
  Checkbox,
  Dropdown,
  DropdownMenu,
  ButtonDisclosure,
} from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import _ from "lodash";

const DropDown = ({
  onSelectAll,
  onSelectNone,
  onSelectAllErrors,
  nodes,
  filterNodeIds,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const { t } = useI18n();
  useEffect(() => {
    let targetNodeIds;

    if (filterNodeIds) {
      const isArray = _.isArray(filterNodeIds);
      targetNodeIds = isArray ? filterNodeIds : _.keys(filterNodeIds);
    } else {
      const allNodeKeys = _.keys(nodes);
      targetNodeIds = _.filter(allNodeKeys, key => nodes[key].depth !== 0);
    }

    const nodeObjects = _.compact(_.map(targetNodeIds, id => nodes[id]));
    const validNodes = _.filter(nodeObjects, node => node.depth !== 0);
    const checkedNodes = _.filter(validNodes, "isChecked");

    const noNodesChecked = checkedNodes.length === 0;
    const allNodesChecked = checkedNodes.length === validNodes.length;

    if (noNodesChecked) {
      setIsChecked(false);
      setIsIndeterminate(false);
    } else if (allNodesChecked) {
      setIsChecked(true);
      setIsIndeterminate(false);
    } else {
      setIsChecked(false);
      setIsIndeterminate(true);
    }
  }, [nodes, filterNodeIds]);

  const handleSelect = ({ key }) => {
    if (key === "all") {
      onSelectAll(filterNodeIds);
      setIsChecked(true);
      setIsIndeterminate(false);
    } else if (key === "allErrors") {
      onSelectAllErrors(filterNodeIds);
      setIsChecked(false);
      setIsIndeterminate(true);
    }
  };

  const handleChange = e => {
    e.stopPropagation();

    const shouldUncheckAll = isChecked || isIndeterminate;

    if (shouldUncheckAll) {
      onSelectNone(filterNodeIds);
      setIsChecked(false);
      setIsIndeterminate(false);
    } else {
      onSelectAll(filterNodeIds);
      setIsChecked(true);
      setIsIndeterminate(false);
    }
  };

  const options = [
    { key: "all", label: t("common:all") },
    { key: "allErrors", label: t("scopeAndSequence:with_errors") },
  ];

  const overlayContent = (
    <DropdownMenu options={options} onClick={handleSelect} />
  );

  return (
    <Dropdown
      overlayClassName={classes.dropdownOverlay}
      overlay={overlayContent}
    >
      <ButtonDisclosure
        className={classes.dropdownLabel}
        variant="neutral"
        type="inline"
        dsVersion="2.0"
      >
        <Checkbox
          isChecked={isChecked}
          isIndeterminate={isIndeterminate}
          onChange={handleChange}
          onClick={e => e.stopPropagation()}
        />
      </ButtonDisclosure>
    </Dropdown>
  );
};

export default DropDown;
